<script>
  import Footer from "layouts/mobile/Footer.svelte";
  import Header from "layouts/mobile/Header.svelte";

  export let logout;
</script>

<div class="wrapper">
  <Header {logout} />
  <slot name="sidebar" />
  <div class="container">
    <div class="inner">
      <slot name="main" />
    </div>
  </div>
  <Footer />
</div>

<style>
  .wrapper {
    position: relative;
  }

  @media only screen and (min-width: 600px) {
    .wrapper {
      display: flex;
      min-height: 100vh;
    }
  }

  .container {
    position: relative;
    flex: 1 1 auto;
  }

  .inner {
    position: relative;
    margin: 80px auto 0;
    padding: 0 20px 24px;
    max-width: 1300px;
  }

  @media only screen and (min-width: 600px) {
    .inner {
      margin: 0 auto;
      padding: 0 20px;
    }
  }
</style>
